<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
        tableId="DcCosCustomerCodeRating"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="customerName" :label="t('operate.r1nt24')">
              <a-input v-model:value="queryForm.customerName" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
            <dc-form-item name="arkCode" :label="t('operate.mo6bp9')">
              <a-input v-model:value="queryForm.arkCode" allowClear :placeholder="t('common.pleaseInput')" />
            </dc-form-item>
          </a-form>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="'ofbu_cuscoderating_edit_btn'">{{
                t('btn.edit')
              }}</a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'ofbu_cuscoderating_delete_btn'">{{
                t('btn.del')
              }}</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <ButtonWrapperTips :text="t('operate.p210o8')">
            <a-button type="primary" @click="addEdit()" v-permission="'ofbu_cuscoderating_add_btn'">{{
              t('btn.add')
            }}</a-button>
          </ButtonWrapperTips>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { findByPageBiScoreList, deleteBiScoreData } from '@/api/overseasSales/businessRuleSetting'
import { useI18n } from 'vue-i18n'
import { DcMessage } from '@dc-platform/dc-components'
import { BigScoreBakcData } from '@/typings/api/overseasSales'
import ButtonWrapperTips from '@/components/ButtonWrapperTips/index.vue'
export default { name: 'DcCosOFbuCustomerCodeRating' }
</script>
<script setup lang="ts">
const { t } = useI18n()
// eslint-disable-next-line func-call-spacing
const editModalRef = ref<{ toggle: (row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const queryForm = reactive({
  arkCode: '',
  customerName: ''
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await findByPageBiScoreList({ ...params })
  callBack(res)
}
const success = () => {
  tableRef.value.fetch()
}
const columns = computed(() => [
  { title: t('operate.r1nt24'), dataIndex: 'customerName' },
  { title: t('operate.mo6bp9'), dataIndex: 'arkCode' },
  { title: t('operate.9bijib'), dataIndex: 'score' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: BigScoreBakcData) => {
  Modal.delete({
    name: row.customerName,
    onOk() {
      deleteBiScoreData(row.id).then(() => {
        DcMessage.success(t('operate.6k2ifb'))
        tableRef.value?.delFetch()
      })
    }
  })
}
</script>

<style scoped></style>
